// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum DistributorPaymentRequestStatus {
  Unknown = "UNKNOWN",
  Paid = "PAID",
  NotPaid = "NOT_PAID",
  PartiallyPaid = "PARTIALLY_PAID",
  AfterDueDate = "AFTER_DUE_DATE",
  PaidAfterDue = "PAID_AFTER_DUE",
}
export default DistributorPaymentRequestStatus;
